<!--Top elements (desktop) -->
@if (!mobileResolution()) {
<app-search-panel [hidden]="navigation() || showOnMap()"></app-search-panel>
@if (!widget()) {
<app-profile-panel [loadingMap]="loadingMap()" [hidden]="navigation() || showOnMap()"></app-profile-panel>
} @else if (widgetSettings()) {
<app-widget-settings-button class="ev-card desktop" [hidden]="navigation() || showOnMap()"></app-widget-settings-button>
}
}

<!--Top elements (mobile) -->
@if (mobileResolution()) {
<app-header-panel [loadingMap]="loadingMap()" [widget]="widget()" [widgetSettings]="widgetSettings()"
  [hidden]="navigation() || selectedDisplayMode()!=DisplayMode.RANGE || showOnMap()"></app-header-panel>
}

<!-- Cookie policy -->
@if (analyticsConsentService.bannerVisible()) {
<app-cookie-panel (choice)="analyticsConsentService.setConsent($event)"></app-cookie-panel>
}

<!-- Address -->
@if (showOnMap(); as shownOnMap) {
  @if (shownOnMap.type == MapElementType.Address) {
  <app-address-panel [addressType]="shownOnMap.data"></app-address-panel>
  }
}

<!-- Chargers -->
@if (showOnMap(); as shownOnMap) {
  @if (shownOnMap.type==MapElementType.FavoriteChargingStation ||
  shownOnMap.type==MapElementType.DisabledChargingStation) {
  <app-charger-panel [charger]="shownOnMap.data" [chargerType]="$any(shownOnMap.type)"></app-charger-panel>
  }
}

<!-- History -->
@if (showOnMap(); as shownOnMap) {
  @if (shownOnMap.type==MapElementType.RouteHistory) {
  <app-history-panel (loadingHistoryChanged)="loadingHistoryChanged($event)"
    [history]="shownOnMap.data"></app-history-panel>
  }
}

<!--Left sidebar-->
@if (selectedDisplayMode()==DisplayMode.ROUTE) {
<app-planning-panel [hidden]="showOnMap()" [loadingMap]="loadingMap()"></app-planning-panel>
}

@if (vehiclePanelEnabled()) {
<button type="button" class="ev-plain-button ev-icon" id="slider-icon" data-testid="main-sliders-btn" (click)="toggleVehiclePanel()">
  <span class="ev-icon-circle">
    <img src="assets/icons/light/ui/sliders_icon.svg" alt="app icon" />
  </span>
</button>
}

<!-- Vehicle panel -->
<app-vehicle-panel [navigation]="navigation()" #vehiclePanel (closePanel)="toggleVehiclePanel()"
  [hidden]="!showVehiclePanel() || showOnMap()">
</app-vehicle-panel>

<!-- Map component -->
<app-map #map [ngClass]="{ 'disableclick': loadingMap()!=null}">
</app-map>

<!-- Wind/temp component -->
<app-wind-panel class="desktop-wind-panel" [hidden]="showOnMap() || navigation()" #windPanelComponent
  [ngClass]="{'route':  selectedDisplayMode()==DisplayMode.ROUTE}"></app-wind-panel>

<!-- Widget mode has no voice input at all: no microphone button, no listen dialog. -->
@if (!widget()) {
<app-voice-input [hidden]="showOnMap()"></app-voice-input>
}

<!-- Navigation hud -->
@if (navigation()) {
<app-navigation-hud></app-navigation-hud>
}

<!-- Guided tutorial coach marks (shown only while TutorialService is active) -->
<app-tutorial></app-tutorial>